// extracted by mini-css-extract-plugin
module.exports = {"navFooter":"nav-footer-module--nav-footer--mZjQc","navList":"nav-footer-module--nav-list--4L-tb"};